import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "./firebase";
import { notifyBugsnag } from "./bugsnag";

// Records that the client accepted our terms and acknowledged the privacy notice.
//
// Both clients tell the user, on the sign-in screen, that continuing means agreeing
// to both documents — so a successful sign-in is the acceptance, and this reports it.
// The backend stamps the versions currently in force and keeps at most one record per
// version, so calling this on every login writes nothing new until a version changes.
//
// Mirrors `recordLoginInfo`: fire-and-forget with an in-memory dedupe, because a
// failure here must never block sign-in or surface to the user.

const recordedUids = new Set<string>();

export function recordLegalAcceptance(uid: string): void {
  if (recordedUids.has(uid)) return;
  recordedUids.add(uid);
  void acceptTerms().catch(notifyBugsnag);
}

/** Exposed for tests; resets the in-memory dedupe set. */
export function _resetLegalAcceptanceForTests(): void {
  recordedUids.clear();
}

async function acceptTerms(): Promise<void> {
  const fn = httpsCallable<void, { success: boolean }>(getFirebaseFunctions(), "legal-acceptTerms");
  await fn();
}
